/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChannelsListParams,
  MediaChannelCreateRequest,
  MediaChannelCreateResponse,
  MediaChannelGetResponse,
  MediaChannelPutResponse,
  MediaChannelUpdateRequest,
  MediaChannelUpdateResponse,
  PaginatedMediaChannelList,
  PatchedMediaChannelUpdateRequest
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Retrieve a paginated list of media channels with optional client filtering. Client users see media channels owned by their client or global channels without an owner.
 * @summary List media channels
 */
export const channelsList = (
    params?: ChannelsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedMediaChannelList>(
      {url: `/api/channels/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getChannelsListQueryKey = (params?: ChannelsListParams,) => {
    return [`/api/channels/`, ...(params ? [params]: [])] as const;
    }

    
export const getChannelsListQueryOptions = <TData = Awaited<ReturnType<typeof channelsList>>, TError = unknown>(params?: ChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChannelsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof channelsList>>> = ({ signal }) => channelsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof channelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChannelsListQueryResult = NonNullable<Awaited<ReturnType<typeof channelsList>>>
export type ChannelsListQueryError = unknown


export function useChannelsList<TData = Awaited<ReturnType<typeof channelsList>>, TError = unknown>(
 params: undefined |  ChannelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelsList>>,
          TError,
          Awaited<ReturnType<typeof channelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChannelsList<TData = Awaited<ReturnType<typeof channelsList>>, TError = unknown>(
 params?: ChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelsList>>,
          TError,
          Awaited<ReturnType<typeof channelsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChannelsList<TData = Awaited<ReturnType<typeof channelsList>>, TError = unknown>(
 params?: ChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List media channels
 */

export function useChannelsList<TData = Awaited<ReturnType<typeof channelsList>>, TError = unknown>(
 params?: ChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChannelsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new media channel
 * @summary Create media channel
 */
export const channelsCreate = (
    mediaChannelCreateRequest: MediaChannelCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MediaChannelCreateResponse>(
      {url: `/api/channels/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mediaChannelCreateRequest, signal
    },
      );
    }
  


export const getChannelsCreateMutationOptions = <TError = MediaChannelCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsCreate>>, TError,{data: MediaChannelCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof channelsCreate>>, TError,{data: MediaChannelCreateRequest}, TContext> => {

const mutationKey = ['channelsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof channelsCreate>>, {data: MediaChannelCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  channelsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChannelsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof channelsCreate>>>
    export type ChannelsCreateMutationBody = MediaChannelCreateRequest
    export type ChannelsCreateMutationError = MediaChannelCreateResponse

    /**
 * @summary Create media channel
 */
export const useChannelsCreate = <TError = MediaChannelCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsCreate>>, TError,{data: MediaChannelCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof channelsCreate>>,
        TError,
        {data: MediaChannelCreateRequest},
        TContext
      > => {

      const mutationOptions = getChannelsCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get a single media channel by ID
 * @summary Retrieve media channel
 */
export const channelsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MediaChannelGetResponse>(
      {url: `/api/channels/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getChannelsRetrieveQueryKey = (id: number,) => {
    return [`/api/channels/${id}/`] as const;
    }

    
export const getChannelsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof channelsRetrieve>>, TError = MediaChannelGetResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChannelsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof channelsRetrieve>>> = ({ signal }) => channelsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof channelsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChannelsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof channelsRetrieve>>>
export type ChannelsRetrieveQueryError = MediaChannelGetResponse


export function useChannelsRetrieve<TData = Awaited<ReturnType<typeof channelsRetrieve>>, TError = MediaChannelGetResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof channelsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChannelsRetrieve<TData = Awaited<ReturnType<typeof channelsRetrieve>>, TError = MediaChannelGetResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof channelsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChannelsRetrieve<TData = Awaited<ReturnType<typeof channelsRetrieve>>, TError = MediaChannelGetResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve media channel
 */

export function useChannelsRetrieve<TData = Awaited<ReturnType<typeof channelsRetrieve>>, TError = MediaChannelGetResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof channelsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChannelsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Fully update a media channel
 * @summary Update media channel (full)
 */
export const channelsUpdate = (
    id: number,
    mediaChannelUpdateRequest: MediaChannelUpdateRequest,
 ) => {
      
      
      return customInstance<MediaChannelPutResponse>(
      {url: `/api/channels/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: mediaChannelUpdateRequest
    },
      );
    }
  


export const getChannelsUpdateMutationOptions = <TError = MediaChannelPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsUpdate>>, TError,{id: number;data: MediaChannelUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof channelsUpdate>>, TError,{id: number;data: MediaChannelUpdateRequest}, TContext> => {

const mutationKey = ['channelsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof channelsUpdate>>, {id: number;data: MediaChannelUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  channelsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChannelsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof channelsUpdate>>>
    export type ChannelsUpdateMutationBody = MediaChannelUpdateRequest
    export type ChannelsUpdateMutationError = MediaChannelPutResponse

    /**
 * @summary Update media channel (full)
 */
export const useChannelsUpdate = <TError = MediaChannelPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsUpdate>>, TError,{id: number;data: MediaChannelUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof channelsUpdate>>,
        TError,
        {id: number;data: MediaChannelUpdateRequest},
        TContext
      > => {

      const mutationOptions = getChannelsUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Partially update a media channel
 * @summary Update media channel
 */
export const channelsPartialUpdate = (
    id: number,
    patchedMediaChannelUpdateRequest: PatchedMediaChannelUpdateRequest,
 ) => {
      
      
      return customInstance<MediaChannelUpdateResponse>(
      {url: `/api/channels/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMediaChannelUpdateRequest
    },
      );
    }
  


export const getChannelsPartialUpdateMutationOptions = <TError = MediaChannelUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsPartialUpdate>>, TError,{id: number;data: PatchedMediaChannelUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof channelsPartialUpdate>>, TError,{id: number;data: PatchedMediaChannelUpdateRequest}, TContext> => {

const mutationKey = ['channelsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof channelsPartialUpdate>>, {id: number;data: PatchedMediaChannelUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  channelsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChannelsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof channelsPartialUpdate>>>
    export type ChannelsPartialUpdateMutationBody = PatchedMediaChannelUpdateRequest
    export type ChannelsPartialUpdateMutationError = MediaChannelUpdateResponse

    /**
 * @summary Update media channel
 */
export const useChannelsPartialUpdate = <TError = MediaChannelUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsPartialUpdate>>, TError,{id: number;data: PatchedMediaChannelUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof channelsPartialUpdate>>,
        TError,
        {id: number;data: PatchedMediaChannelUpdateRequest},
        TContext
      > => {

      const mutationOptions = getChannelsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Auto-wrapped deletion with proper schema
 */
export const channelsDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/channels/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getChannelsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof channelsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['channelsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof channelsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  channelsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChannelsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof channelsDestroy>>>
    
    export type ChannelsDestroyMutationError = unknown

    export const useChannelsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof channelsDestroy>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof channelsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getChannelsDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    